import React, { useState } from "react";
import { MessageSquarePlus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { CreateConversationModal } from "./CreateConversationModal";
import type { ConversationData } from "../../types/conversation";

interface NewConversationButtonProps {
  variant?: 'icon' | 'button' | 'menu-item';
  onSuccess?: (conversation: ConversationData) => void;
}

export function NewConversationButton({ 
  variant = 'button', 
  onSuccess 
}: NewConversationButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const renderButton = () => {
    switch (variant) {
      case 'icon':
        return (
          <Button
            size="icon"
            variant="ghost"
            onClick={() => setIsModalOpen(true)}
            className="rounded-full"
            aria-label="New conversation"
          >
            <Plus className="h-4 w-4" />
          </Button>
        );
      case 'menu-item':
        return (
          <DropdownMenuItem 
            onSelect={(e) => {
              e.preventDefault();
              setIsModalOpen(true);
            }}
            className="cursor-pointer"
          >
            <MessageSquarePlus className="mr-2 h-4 w-4" />
            New Conversation
          </DropdownMenuItem>
        );
      default:
        return (
          <Button onClick={() => setIsModalOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            New Conversation
          </Button>
        );
    }
  };
  
  return (
    <>
      {renderButton()}
      <CreateConversationModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  );
}